<template>
  <div class="position-relative">
    <div class="position-absolute top-0 end-0">
      <i
        :class="'fa fa-angle-' + (expanded ? 'up' : 'down') + ' text-primary'"
        style="cursor: pointer"
        @click="expanded = !expanded"
      ></i>
    </div>
    <div v-if="expanded">
      <div v-for="(tag, key) in tags" :key="key">
        {{ tag.name.de }}
      </div>
    </div>
    <div v-if="!expanded">
      {{ tags[0] ? tags[0].name.de : '' }}
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    tags: { type: Object, default: () => {} },
  },
  setup() {
    const expanded = ref(false);

    return {
      expanded,
    };
  },
};
</script>
